import { AdminSearchRequestNoResultsFoundContainer } from "components/AdminSettings/AdminSearchTable.styles.ts";
import { ContactCareForSearchHelpText } from "constants/text.ts";

interface NoResultsBoxProps {
	headerText: string;
	subheaderText: string;
	bulletList?: string[];
}

// TODO: Make this component global across entire application
export const NoResultsBox = ({ headerText, subheaderText, bulletList }: NoResultsBoxProps) => {
	return (
		<AdminSearchRequestNoResultsFoundContainer>
			<img
				src="/assets/NoOrdersSadBoxImage.svg"
				alt="No Results Found"
				data-testid="admin-search-no-results-found"
			/>
			<h1>{headerText}</h1>
			<div>
				<div>{subheaderText}</div>
				{bulletList && bulletList.length > 0 && (
					<ul>
						{bulletList.map((bullet) => (
							<li key={bullet}>{bullet}</li>
						))}
					</ul>
				)}
			</div>
			<div>{ContactCareForSearchHelpText}</div>
		</AdminSearchRequestNoResultsFoundContainer>
	);
};
